import React from 'react';
import { styled } from '@mui/system';

const Overlay = styled('div')`
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(8px); /* blur effect */
  z-index: 9999; /* ensure it's above other content */
`;

const CircularDottedLoading = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DottedCircle = styled('div')`
  width: 100px; /* Increase the size */
  height: 100px; /* Increase the size */
  border-radius: 50%;
  position: relative;
  border: 3px dashed transparent; /* Adjust border thickness */
  border-top: 3px dashed ${props => props.color || '#1976d2'};
  border-right: 3px dashed ${props => props.color || '#1976d2'};
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingMessage = styled('div')`
  color: #fff;
  margin-top: 20px;
`;

const CircularDottedLoadingIndicator = ({ color }) => {
  return (
    <CircularDottedLoading>
      <DottedCircle color={color} />
      <LoadingMessage style={{color:'black',fontWeight:'bold'}}>Loading data...</LoadingMessage>
    </CircularDottedLoading>
  );
};

const LoadingOverlay = () => {
  return (
    <Overlay>
      <CircularDottedLoadingIndicator color="#000080" />
    </Overlay>
  );
};

export default LoadingOverlay;
